<div class="employee-sign-up-success">
  <div class="content">
    <img
      ngSrc="assets/graphic-error.svg"
      alt=""
      class="d-md-none"
      height="142"
      width="212" />
    <h2 class="mt-5 mt-md-0">Oh no!</h2>
    <p><strong>The link has expired.</strong></p>
    <p>Please reach out to your admin for more information.</p>
    <app-download-app-buttons></app-download-app-buttons>
  </div>
</div>
